module.exports = __webpack_public_path__ + "img/topic2-b.d2095277.jpg";